import React, { useState, useEffect } from "react";

interface GameControlsProps {
  moves: number;
  canUndo: boolean;
  phase: string;
  blind: boolean;
  submitted: boolean;
  startedAt: number;
  onUndo: () => void;
  onReset: () => void;
  onSubmit: () => void;
}

export function GameControls({
  moves,
  canUndo,
  phase,
  blind,
  submitted,
  startedAt,
  onUndo,
  onReset,
  onSubmit,
}: GameControlsProps) {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    if (phase === "won") return;
    const interval = setInterval(() => {
      setElapsed(Date.now() - startedAt);
    }, 1000);
    return () => clearInterval(interval);
  }, [startedAt, phase]);

  const minutes = Math.floor(elapsed / 60000);
  const seconds = Math.floor((elapsed % 60000) / 1000);
  const timeStr = `${minutes}:${String(seconds).padStart(2, "0")}`;

  return (
    <div className="flex items-center gap-4 flex-wrap justify-center">
      <button
        onClick={onUndo}
        disabled={!canUndo || phase === "won"}
        className="px-4 py-2 bg-slate-800 hover:bg-slate-700 disabled:opacity-40 disabled:cursor-not-allowed rounded-lg text-sm font-medium transition-colors border border-slate-600"
      >
        Undo
      </button>
      <button
        onClick={onReset}
        className="px-4 py-2 bg-slate-800 hover:bg-slate-700 rounded-lg text-sm font-medium transition-colors border border-slate-600"
      >
        Reset
      </button>

      {blind && phase !== "won" && (
        <button
          onClick={onSubmit}
          className="px-4 py-2 bg-cyan-700 hover:bg-cyan-600 rounded-lg text-sm font-medium transition-colors border border-cyan-500"
        >
          {submitted ? "Check Again" : "Submit"}
        </button>
      )}

      <div className="text-sm text-slate-400">
        <span className="text-white font-mono">{moves}</span>
        {" moves"}
        <span className="mx-2 text-slate-600">|</span>
        <span className="font-mono text-cyan-400">{timeStr}</span>
      </div>
    </div>
  );
}
